import React, { useState } from "react"
import {TextArea} from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCase } from "../../../redux/currentCase/selectors";
import { advanceFactoryCase } from "../../../redux/currentCase/thunks";
import { validateAdvanceFactoryCaseData } from "../case/formValidationFunctions";
import { regressFactoryCase } from "../../../redux/caseForms/thunks";
import { getCommentByCaseId } from "../../../redux/contract/thunks";
import { PanelDialogue } from "../../common/PanelDialogue";
import CustomSelectBox from "../../common/CustomSelectBox";
import { selectFactoryAdvanceOptions, selectFactoryNode } from "../../../redux/factoryAdvanceOptions/selectors";


function AdvanceFactoryCaseForm(props){
    const {showAdvanceFactoryCaseForm, setShowAdvanceFactoryCaseForm, showRegressFactoryCaseForm, setShowRegressFactoryCaseForm, handleShowForms, setDisabledButtom} = props;
    const currentCase = useSelector(selectCurrentCase)
    const [disabledActionButtons, setDisabledActionButtons] = useState(false)
    const dispatch = useDispatch();
    const isAdvance = showAdvanceFactoryCaseForm
    const anchorEl = document.getElementById(isAdvance ? "advance-factory-button" : "regress-factory-button")
    const advanceOptions = useSelector(selectFactoryAdvanceOptions);
    const isConditionalNode = isAdvance && currentCase.factoryAdvanceConditional && advanceOptions.length > 1;
    const nodeTitle = useSelector(selectFactoryNode);

    const [formData, setFormData] = useState({
        comment: "",
        conditionValue: null
    })


    async function handleSubmit(){
        setDisabledActionButtons(true);
        const submitData = {...formData, isConditional: isConditionalNode, caseId: currentCase.caseId, processTypeId: currentCase.factoryProcessTypeId, processId: currentCase.factoryProcessId, expedient: currentCase.caseNumber}

        if(!validateAdvanceFactoryCaseData(submitData, dispatch)){
            setDisabledActionButtons(false);
            return
        }
        const factoryAction = isAdvance? advanceFactoryCase : regressFactoryCase;
        dispatch(factoryAction({body: submitData})).then(
            response=>{
                if (response.payload)
                {
                    setFormData(
                        {
                            comment: "",
                        }
                    )
                    setDisabledButtom(prevState=>({...prevState, advanceFactoryCase: true}))
                    dispatch(getCommentByCaseId({query: `?caseId=${currentCase.caseId}`}));
                }
                setDisabledActionButtons(false);
                setShowAdvanceFactoryCaseForm(false)
                setShowRegressFactoryCaseForm(false)
            }
        )

    }

    return(
        <PanelDialogue
            open={showAdvanceFactoryCaseForm || showRegressFactoryCaseForm}
            anchorEl={anchorEl}
            title={isAdvance? `Avanzar caso en fábrica${isConditionalNode? ` - (${nodeTitle})` : ""}` : "Retroceder caso en fábrica"}
            cancelFunction={()=>handleShowForms(isAdvance? "advanceFactoryCase" : "regressDactoryCase")}
            submitFunction={handleSubmit}
            submitText={isAdvance? "Avanzar" : "Retroceder"}
            disableButtons={disabledActionButtons}
        >
             {isConditionalNode &&
                <div style={{marginBottom: "1rem"}}>
                    <CustomSelectBox
                        label="Decisión"
                        noDataText="Cargando decisiones"
                        dataSource = { advanceOptions }
                        displayExpr = {"value"}
                        valueExpr={"value"}
                        value = {formData.conditionValue}
                        onValueChanged = { (e) => setFormData(prevState=> ({...prevState, conditionValue: e.value})) }
                    />
                </div>
                }
                <TextArea label="Comentários fábrica" labelMode="floating" height={150} value={formData.comment} onValueChanged={(e)=>setFormData(prevState=>({...prevState, comment: e.value}))}/>
        </PanelDialogue>
    )
}

export {AdvanceFactoryCaseForm}